import { Component } from '@angular/core';

@Component({
  selector: 'app-textbox-showcase',
  templateUrl: './textbox-showcase.component.html',
  styleUrls: ['./textbox-showcase.component.scss']
})
export class TextboxShowcaseComponent {
  basicValue: string = '';
  emailValue: string = '';
  passwordValue: string = '';
  numberValue: string = '';
  iconPrefixValue: string = '';
  iconSuffixValue: string = '';
  bothIconsValue: string = '';
  clearButtonValue: string = 'Clear me';
  errorValue: string = '';
  requiredValue: string = '';
  fullWidthValue: string = '';

  onValueChange(newValue: string, fieldName: string): void {
    console.log(`${fieldName} changed to:`, newValue);
  }

  getTextboxClasses(size: string): string {
    return `showcase-card size-demo-${size}`;
  }
}
